import { gql } from '@apollo/client'

import { ACCOUNT_FRAGMENT } from '../fragments'

export const GET_CURRENT_ACCOUNT = gql`
  query CurrentAccount {
    currentAccount {
      ...Account
    }
  }
  ${ACCOUNT_FRAGMENT}
`
